/* RESPONSIBLE TEAM: team-inbox-management */
export default function toBackendPermissionKey(frontEndPermissionKey) {
  return frontEndPermissionKey.replace('can_', '');
}
